import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首頁' },
  { path: '/about', label: '關於我們' },
  { path: '/services', label: '服務項目' },
  { path: '/news', label: '最新資訊' },
  { path: '/contact', label: '聯絡方式' },
];

const logoUrl = 'https://storage.readdy-site.link/project_files/3596fc25-c69f-44a2-abe5-af3ab65b5565/e8b3a63e-77b3-40d1-bcf9-c504e7feaaa0_logo-Photoroom.png?v=da203c0422d47544374c94eda10a1af6';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="flex items-center gap-2">
              <img
                src={logoUrl}
                alt="得運智科"
                className="h-[3.75rem] md:h-[4.5rem] w-auto object-contain"
              />
              <div className="flex flex-col">
                <span
                  className={`text-lg md:text-xl font-bold tracking-tight transition-colors duration-300 whitespace-nowrap ${
                    isScrolled ? 'text-primary-900' : 'text-white'
                  }`}
                >
                  得運智科
                </span>
                <span
                  className={`text-xs transition-colors duration-300 whitespace-nowrap ${
                    isScrolled ? 'text-foreground-500' : 'text-white/70'
                  }`}
                >
                  讓企業升級更有方向
                </span>
              </div>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 relative group whitespace-nowrap ${
                    isScrolled
                      ? 'text-foreground-700 hover:text-primary-600'
                      : 'text-white/90 hover:text-white'
                  } ${location.pathname === link.path ? (isScrolled ? 'text-primary-600' : 'text-white') : ''}`}
                >
                  {link.label}
                  <span
                    className={`absolute -bottom-1 left-0 h-0.5 bg-accent-500 transition-all duration-300 ${
                      location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                    }`}
                  />
                </Link>
              ))}
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden p-2 transition-colors duration-300 w-10 h-10 flex items-center justify-center ${
                isScrolled ? 'text-primary-900' : 'text-white'
              }`}
              aria-label="切換選單"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`} />
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-primary-900/98 backdrop-blur-md z-40">
          <div className="flex flex-col items-center justify-center h-full gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-xl font-medium text-white/90 hover:text-white transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path ? 'text-accent-500' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
}